import React from 'react';
import { Bar } from 'react-chartjs-2';

const LEGENDA = {
  display: true,
  position: "bottom",
  fullWidth: true,
  reverse: false
};

export default class BarGraph extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      renderizar: false,
      dados: {
        labels: [],
        datasets: [
          {
            label: "Nota de atendimento",
            type: "bar",
            backgroundColor: "rgba(23,162,184,.2)",
            borderColor: "rgba(23,162,184,1)",
            borderWidth: 1,
            hoverBackgroundColor: "rgba(23,162,184,.4)",
            hoverBorderColor: "rgba(23,162,184,1)",
            data: []
          },
          {
            label: "Nota de layout",
            type: "bar",
            backgroundColor: "rgba(255,193,7,.2)",
            borderColor: "rgba(255,193,7,1)",
            borderWidth: 1,
            hoverBackgroundColor: "rgba(255,193,7,.4)",
            hoverBorderColor: "rgba(255,193,7,1)",
            data: []
          },
          {
            label: "Variação das notas do atendimento",
            type: "line",
            fill: false,
            borderColor: "#117a8b",
            backgroundColor: "#117a8b",
            pointBorderColor: "#117a8b",
            pointBackgroundColor: "#117a8b",
            pointHoverBackgroundColor: "#117a8b",
            pointHoverBorderColor: "#117a8b",
            data: []
          },
          {
            label: "Variação das notas do layout",
            type: "line",
            fill: false,
            borderColor: "#d39e00",
            backgroundColor: "#d39e00",
            pointBorderColor: "#d39e00",
            pointBackgroundColor: "#d39e00",
            pointHoverBackgroundColor: "#d39e00",
            pointHoverBorderColor: "#d39e00",
            data: []
          }
        ]
      }
    }
  }

  componentDidMount () {
    if (this.props.publicacoes) {
      let dados = this.state.dados;
      for (let i = 0; i < this.props.publicacoes.length; i++) {
        let publicacao = this.props.publicacoes[i];
        dados.labels.push(new Date(publicacao.pesquisas.dataResposta).toLocaleDateString("pt-br", {timezome: "UTC"}));
        dados.datasets[0].data.push(publicacao.pesquisas.notaAtendimento);
        dados.datasets[2].data.push(publicacao.pesquisas.notaAtendimento);
        dados.datasets[1].data.push(publicacao.pesquisas.notaDesign);
        dados.datasets[3].data.push(publicacao.pesquisas.notaDesign);
      }
      this.setState({dados, renderizar: true});
    }
  }

  render () {
    return (
      <div>
        <Bar
          data={this.state.dados}
          width={500}
          height={500}
          options={{maintainAspectRatio: false}}
          legend={LEGENDA}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Graficos/Bar.js